// extracted by css-extract-rspack-plugin
export default {"chatButton":"chat-button--hBL0lPHalhco43Lv"};